import Navbar from './Navbar';
import Footer from './Footer';
import { Outlet, useLocation } from 'react-router-dom';

function Layout() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <>
      <Navbar />
      <div className="min-h-screen">
        <Outlet />
      </div>
      {!isHomePage && <Footer />}
    </>
  );
}

export default Layout;
